import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
import { MessageWithCategoryAndType } from "../../../../utils/product/getPromoMessaging.ts";
import { ListItem } from "../../../__shared__/ListItem/ListItem";
import { SaleTagIcon } from "@/components/__shared__/SaleTagIcon/SaleTagIcon.tsx";
import styles from "./SpecialOffersListItem.module.scss";

type Props = {
  promotions: MessageWithCategoryAndType[];
  onClick: () => void;
  isBlackOverride: boolean;
  specialOffersVariant?: string;
};

export const SpecialOffersListItem = ({
  promotions,
  onClick,
  isBlackOverride,
  specialOffersVariant,
}: Props) => {
  if (specialOffersVariant === "A") {
    const variantAListItemContent = (
      <>
        <p
          className={styles.listItemHeading}
          data-testid="special-offers-list-item-label"
        >
          {promotions.length > 1 ? `Offers (${promotions.length})` : `Offer`}
        </p>
        <div className={styles.tagGroup}>
          <div
            className={styles.tagBadge}
            data-testid="special-offers-list-item-tag-badge"
          >
            <SaleTagIcon type="small" />
            <p>{promotions[0]?.tag}</p>
          </div>
          {promotions.length > 1 ? (
            <div
              className={styles.tagBadgeNumber}
              data-testid="special-offers-list-item-number-badge"
            >
              <SaleTagIcon type="small" />
              {`+${promotions.length - 1} more`}
            </div>
          ) : null}
        </div>
      </>
    );

    return (
      <ListItem
        trailingIcon={<ArrowRight />}
        onClick={onClick}
        label={variantAListItemContent}
        data-testid="special-offers-drawer-header"
        showTopBorder
        showBottomBorder
        isOffer={!isBlackOverride}
        dataComponent="SpecialOffers"
      />
    );
  } else if (specialOffersVariant === "B") {
    const variantBListItemContent = (
      <div className={styles.listItemContent}>
        <p
          className={styles.listItemHeading}
          data-testid="special-offers-list-item-label"
        >
          {promotions.length > 1 ? `Offers (${promotions.length})` : `Offer`}
        </p>
        <div className={styles.titleGroup}>
          <div
            className={styles.titleBadge}
            data-testid="special-offers-list-item-title-badge"
          >
            <SaleTagIcon type="small" />
            <p>{promotions[0]?.clippedTitle}</p>
          </div>
          {promotions.length > 1 ? (
            <div
              className={styles.titleBadgeNumber}
              data-testid="special-offers-list-item-number-badge"
            >
              <SaleTagIcon type="small" />
              <p>{`+${promotions.length - 1} more`}</p>
            </div>
          ) : null}
        </div>
      </div>
    );

    return (
      <ListItem
        trailingIcon={<ArrowRight />}
        onClick={onClick}
        label={variantBListItemContent}
        data-testid="special-offers-drawer-header"
        showTopBorder
        showBottomBorder
        isOffer={!isBlackOverride}
        dataComponent="SpecialOffers"
      />
    );
  } else {
    return (
      <ListItem
        trailingIcon={<ArrowRight />}
        onClick={onClick}
        label={
          promotions.length === 1
            ? "Special offer"
            : `Special offers (${promotions.length})`
        }
        data-testid="special-offers-drawer-header"
        showTopBorder
        showBottomBorder
        isOffer={!isBlackOverride}
        dataComponent="SpecialOffers"
      />
    );
  }
};
